import * as React from 'react';
import styled from 'styled-components';
import { compose, space, color, layout, typography, SpaceProps, ColorProps, LayoutProps, TypographyProps } from 'styled-system';
import { nanoid } from 'nanoid';
export type IconProps = SpaceProps & ColorProps & LayoutProps & TypographyProps;
const SvgComponent = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement> & {
  title?: any;
}>(({
  title,
  ...props
}, svgRef) => {
  const [titleId] = React.useState(() => title ? nanoid() : undefined);
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="1em" height="1em" ref={svgRef} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M16.104 5.17a1 1 0 011.36-.39 8.347 8.347 0 014.3 7.3 8.347 8.347 0 01-4.305 7.303 1 1 0 01-.97-1.75 6.347 6.347 0 00.004-11.104 1 1 0 01-.39-1.36zm-1.797 3.293a1 1 0 011.362-.38 4.59 4.59 0 01-.005 8.003 1 1 0 11-.98-1.743 2.59 2.59 0 00.003-4.517 1 1 0 01-.38-1.363zm-8.37.071h-1.11C3.818 8.534 3 9.294 3 10.23v3.896c0 .936.818 1.696 1.827 1.696h1.226l4.933 3.216c.13.083.28.127.432.127.416 0 .753-.312.753-.699V5.815a.662.662 0 00-.137-.402c-.236-.315-.705-.392-1.048-.17L5.937 8.534z" clipRule="evenodd" /></svg>;
});
export const IconSystemV2CourseVolume2 = styled(SvgComponent)<IconProps>({
  flex: 'none',
  verticalAlign: 'middle'
}, compose(space, color, layout, typography));